import React, { useEffect } from 'react';

import { ResizableBox as ReactResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

interface Props {
  children?: any;
  width?: any;
  height?: any;
  resizable?: boolean;
  style?: any;
  className?: any;
}

export default function ResizableBox({
  children,
  width = 600,
  height = 300,
  resizable = true,
  style = {},
  className = '',
}: Props) {
  return (
    <div style={{ /*  marginLeft: 20 ,*/ marginBottom: 20 }}>
      {resizable ? (
        // resize jen na ose Y
        <ReactResizableBox
          minConstraints={[width, 300]}
          maxConstraints={[width, 5000]}
          width={width}
          height={height}
        >
          <div
            style={{
              // boxShadow: '0 20px 40px rgba(0,0,0,.1)',
              ...style,
              width: '100%',
              height: '100%',
            }}
            className={className}
          >
            {children}
          </div>
        </ReactResizableBox>
      ) : (
        <div
          style={{
            width: `${width}px`,
            height: `${height}px`,
            // boxShadow: '0 20px 40px rgba(0,0,0,.1)',
            ...style,
          }}
          className={className}
        >
          {children}
        </div>
      )}
    </div>
  );
}
